import { useEffect, useRef } from 'react';

type ScrollIntoViewOptions = {
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
  inline?: ScrollLogicalPosition;
};

/**
 * Return a ref to attach to the collapsible content.
 * When `isOpen` passes to true, scroll the content into view (after the frame to let the animation).
 */
export function useScrollIntoViewWhenOpen(
  isOpen: boolean,
  options: ScrollIntoViewOptions = {},
) {
  const ref = useRef<HTMLDivElement>(null);
  const { behavior = 'smooth', block = 'center' } = options;

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const el = ref.current;
    if (!el) {
      return;
    }
    const id = requestAnimationFrame(() => {
      el.scrollIntoView({ behavior, block });
    });
    return () => cancelAnimationFrame(id);
  }, [isOpen, behavior, block]);

  return ref;
}
